// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__E0DCL","question":"Question_question__1D0If","description":"Question_description__3f9Su"};